import styled from "styled-components";

export const CardsWithGrid = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  margin-top: 24px;
  grid-template-columns: auto;

  @media screen and (min-width: 1050px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 1640px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 2000px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (min-width: 2400px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media screen and (min-width: 2700px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;
